import React from 'react';
import { Zap, Lock, ShieldCheck, Shield } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackEvent } from '../hooks/useMetaPixel';
export function CtaFinal() {
  const revealRef = useScrollReveal();
  return <section id="cta-final" className="py-[100px] px-6 text-center" style={{
    background: 'linear-gradient(160deg, #0f0c00 0%, #0a0a0a 100%)'
  }} data-id="element-151">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-152">
        <h2 className="font-playfair text-[clamp(30px,5vw,58px)] font-bold mb-5 leading-[1.15]" data-id="element-153">
          Tienes dos opciones:
          <br data-id="element-154" />
          seguir experimentando
          <br data-id="element-155" />o <em className="italic text-oro-claro" data-id="element-156">cocinar con método</em>.
        </h2>

        <p className="text-[16px] text-white/65 max-w-[540px] mx-auto mb-9 leading-[1.7]" data-id="element-157">
          La pasta que quieres ya existe. Solo necesitas el sistema correcto
          para hacerla. Por $12 no hay argumento válido para esperar.
        </p>

        <a href="https://pay.hotmart.com/P104827255Q?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
        content_name: 'CTA Final',
        value: 12,
        currency: 'USD'
      })} className="btn-cta inline-flex items-center justify-center gap-2 text-[16px] px-14 py-5" data-id="element-158">
          <Zap size={18} className="fill-current" data-id="element-159" /> Obtener Acceso Inmediato
        </a>

        <div className="flex flex-wrap justify-center items-center gap-6 mt-5" data-id="element-160">
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-161">
            <Lock size={13} className="text-oro" data-id="element-162" /> Compra 100% Segura
          </span>
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-163">
            <ShieldCheck size={13} className="text-oro" data-id="element-164" /> Garantía 7 días
          </span>
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-165">
            <Shield size={13} className="text-oro" data-id="element-166" /> Privacidad Protegida
          </span>
        </div>

        <div className="inline-flex items-center gap-2 bg-oro/10 border border-oro/40 rounded-sm px-3.5 py-1.5 text-[12px] text-oro-claro font-semibold tracking-[1px] mt-7" data-id="element-167">
          <span className="text-[11px] font-bold" data-id="element-168">TM</span> Incluye El Método
          Italiano™ + 3 Bonos Exclusivos
        </div>
      </div>
    </section>;
}